import React from 'react'
import { OutlinedInput, withStyles } from '@material-ui/core'

const CustomsOutlinedInput = withStyles((theme) => ({
  root: {
    borderRadius: '8px',
    backgroundColor: theme.colors.white,
    color: theme.colors['grey-400'],
    padding: '6px 10px',
    '&:hover': {
      backgroundColor: theme.colors['primary-lighter'],
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors['grey-100'],
    },
    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors['grey-200'] + '!important',
    },
    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px !important',
      borderColor: theme.colors['grey-200'] + '!important',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: `${theme.colors['red-500']} !important`,
    },
    '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `${theme.colors['red-500']} !important`,
    },
    '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${theme.colors['red-500']} !important`,
    },
    '&.MuiInputBase-root.Mui-disabled': {
      backgroundColor: theme.colors['neutrals-100'] + '!important',
    },
  },
  input: {
    padding: '6px',
    color: theme.colors.primary + '!important',
  },
}))(OutlinedInput)

const Input = (props) => {
  // Props -> OutlinedInput MUI Doc
  return <CustomsOutlinedInput {...props} />
}

export default Input
